import { Path, Svg, View } from '../../../compiler'

const CheckIcon = ({ style, color = 'currentColor' }) => {
  return (
    <View style={style}>
      <Svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 16 16'
        fill={color}
        className='size-4'
      >
        <Path
          fillRule='evenodd'
          d='M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z'
          clipRule='evenodd'
        />
      </Svg>
    </View>
  )
}

export default CheckIcon
